import { render, staticRenderFns } from "./package-type-switch.vue?vue&type=template&id=78040c70&scoped=true&"
import script from "./package-type-switch.vue?vue&type=script&lang=js&"
export * from "./package-type-switch.vue?vue&type=script&lang=js&"
import style0 from "./package-type-switch.vue?vue&type=style&index=0&id=78040c70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78040c70",
  null
  
)

export default component.exports